"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerpackungProperties = void 0;
const ArticleProperties_1 = require("../ArticleProperties");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Verpackung properties that are used by the individual applications.
 */
class VerpackungProperties {
}
exports.VerpackungProperties = VerpackungProperties;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE;
VerpackungProperties[_a] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
VerpackungProperties[_b] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
//# sourceMappingURL=VerpackungProperties.js.map